import Vue from "vue";
import VueAxios from "vue-axios";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import './plugins/base'
import http from "./service/http";
import "@mdi/font/css/materialdesignicons.css";
import comUtils from './utils/comUtils';
import VueQuillEditor from 'vue-quill-editor';
import 'quill/dist/quill.core.css';
import 'quill/dist/quill.snow.css';
import 'quill/dist/quill.bubble.css';
import {snackbar} from "@/components/snackbar"
import {alertbar} from "@/components/alertbar"
import Viewer from 'v-viewer';
import 'viewerjs/dist/viewer.css';
// import { firstMenu } from './privileges'
// eslint-disable-next-line no-unused-vars


Vue.config.productionTip = false;
if(process.env.NODE_ENV === "production"){
    Vue.config.devtools = false;
    Vue.config.debug = false;
    Vue.config.silent = true;
} else {
    Vue.config.debug = true;
}

Vue.prototype.comUtils = comUtils

Vue.use(VueAxios, http);
Vue.use(VueQuillEditor);
Vue.use(snackbar);
Vue.use(alertbar);
Vue.use(Viewer, {
    defaultOptions: {
        zIndex: 1,
        inline: false,
        button: true,
        navbar: false,
        title: false,
        toolbar: true,
        tooltip: true,
        movable: true,
        zoomable: true,
        rotatable: true,
        scalable: true,
        transition: true,
        fullscreen: false,
        keyboard: false,
        loop: false,
    },
    url:"data-source",  
    filter(img){
        let dataSource = img.getAttribute("data-source")
        if(dataSource == null || dataSource == undefined){
            return false
        }else{
            return true
        }
    }
})
router.beforeEach((to, from, next) => {
    // if (!sessionStorage.getItem('token') && isSubMenuAccessible(to.fullPath)) {
    // console.info("accessToken:"+sessionStorage.getItem('accessToken'));
    if (!sessionStorage.getItem('accessToken')) {
        if (
            to.matched.length > 0 &&
            !to.matched.some(record => record.meta.requiresAuth)
        ) {
            // console.info("1go to next")
            next()
        } else {
            // console.info("2go to login")
            next({path: '/login'})
        }
    } else {
        if (to.path !== '/login') {
            if(to.path ==='/' || to.path ===''){
                // console.info("5go to next")
                next(to.path)
            } else {
                if(from.path === '/error'){
                    next({path: '/login'})
                }
                else {
                    // console.info("3go to next" + to.path)
                    next()
                }
            }
        } else {
            // console.info("4go to next"+to.path)
            next()
        }
    }
})

new Vue({
    router,
    store,
    render: (h) => h(App),
}).$mount("#app");